import axios from '@axios'
import { $themeConfig } from '@themeConfig'
import baseConfig from '@/config/index'
const TICKET_SERVICE_PATH = baseConfig.BASE_PATH

export default {
  namespaced: true,
  state: {
    isVerticalMenuCollapsed: $themeConfig.layout.menu.isCollapsed,
  },
  getters: {},
  mutations: {
    UPDATE_VERTICAL_MENU_COLLAPSED(state, val) {
      state.isVerticalMenuCollapsed = val
    },

  },
  actions: {
    fetchSpaceListByWorkspace(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(TICKET_SERVICE_PATH + '/space/spaceListByWorkspace', payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
